import { RootState } from 'redux/store';
import { createSelector } from 'reselect';

const drawerSelector = createSelector(
  (state: RootState) => state.app.drawer,
  drawer => drawer,
);

export { drawerSelector };
